import React from "react";
import SectionClinicas from "../components/SectionClinicas/SectionClinicas";

const Clinicas = () => {
  return (
    <div>
      <SectionClinicas />
    </div>
  );
};

export default Clinicas;
